import { InjectionToken } from '@angular/core';
export var SGWTConnectRequestPredicate = new InjectionToken('SGWTConnectRequestPredicate');
